import { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { QuerySummary as QuerySummaryComponent } from '@coveo/headless';

interface IQuerySummaryProps {
  querySummary: React.MutableRefObject<QuerySummaryComponent>;
}
export default function QuerySummary({ querySummary }: IQuerySummaryProps) {
  const [querySummaryState, setQuerySummaryState] = useState(querySummary.current.state);
  useEffect(() => {
    const unsub = querySummary.current.subscribe(() => setQuerySummaryState(querySummary.current.state));
    return function cleanup() {
      unsub();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function renderNoResults() {
    return <></>;
  }

  function renderBold(input: string) {
    return <span className="bold">{input}</span>;
  }

  function renderRange() {
    return <> {renderBold(`${querySummaryState.firstResult}-${querySummaryState.lastResult}`)}</>;
  }

  function renderTotal() {
    return <> of {renderBold(querySummaryState.total.toString())}</>;
  }

  function renderQuery() {
    if (querySummaryState?.hasQuery) {
      return <> for {renderBold(querySummaryState.query)}</>;
    }
  }
  function renderDuration() {
    return ` in ${querySummaryState.durationInSeconds} seconds`;
  }

  function renderHasResults() {
    return (
      <Box className="caption">
        Results
        {renderRange()}
        {renderTotal()}
        {renderQuery()}
        {renderDuration()}
      </Box>
    );
  }

  if (querySummaryState?.hasResults) {
    return renderHasResults();
  }
  return renderNoResults();
}
